import { ENV } from '@/shared/lib/env';
import Bugsnag, { type BrowserConfig } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

export const BUGSNAG_API_KEY = ENV.bugsnagApiKey;

export const bugsnagConfiguration: BrowserConfig = {
  apiKey: BUGSNAG_API_KEY,
  appVersion: '1.0.0',
  releaseStage: ENV.mode,
  plugins: [new BugsnagPluginReact()],
  onError: (event) => {
    const errorMessagesToIgnore = [
      'Failed to fetch dynamically imported module',
      'Importing a module script failed',
      "'Route' of 'undefined'",
      'Failed to load module script:',
      'Loading chunk',
      'ChunkLoadError',
    ];

    if (event.errors && event.errors.length > 0) {
      const shouldIgnore = event.errors.some((error) => {
        return errorMessagesToIgnore.some(
          (message) =>
            error.errorMessage && error.errorMessage.includes(message)
        );
      });

      if (shouldIgnore) {
        return false;
      }
    }
  },
};

if (!ENV.isDevelopment && BUGSNAG_API_KEY) {
  Bugsnag.start(bugsnagConfiguration);

  if (import.meta.env.VITE_FORCE_ERROR === 'true') {
    Bugsnag.notify(new Error(`[FORCE_ERROR] Bugsnag test — ${ENV.mode}`));
  }
}

export const BugsnagErrorBoundary =
  !ENV.isDevelopment && BUGSNAG_API_KEY
    ? Bugsnag.getPlugin('react')?.createErrorBoundary(React)!
    : React.Fragment;
